<template>
  <div class="pass">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Passthrough"
};
</script>
